<template>
  <div class="role--table">
    <div class="role--table--head">
      <ul>
        <li class="li_1">
          <div>{{ $t("menu.menuName") }}</div>
          <!-- <el-checkbox v-model="expandAll" class="checkbox">展开/折叠</el-checkbox> -->
          <el-checkbox v-model="strictly" class="checkbox">父子联动</el-checkbox>
        </li>
        <li>{{ $t("menu.menuType") }}</li>
      </ul>
    </div>
    <div class="role--table--body">
      <el-tree
        ref="Tree"
        :data="treeData"
        :default-checked-keys="defaultCheckedKeys"
        show-checkbox
        node-key="id"
        :expand-on-click-node="false"
        :default-expanded-keys="[defaultRootId]"
        :check-strictly="!strictly"
        @check-change="checkChange"
      >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span>{{ node.label }}</span>
          <span v-if="showTagTypes">
            <el-tag
              :type="data.type === '菜单' ? 'success' : data.type === '按钮' ? 'warning' : 'danger'"
            >
              {{ data.type }}
            </el-tag>
          </span>
          <span v-else>
            {{ data.type }}
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuTree",
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    showTagTypes: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hasChangeCheck: false,
      showTag: false,
      strictly: false,
      expandAll: true,
      defaultRootId: ""
    };
  },
  watch: {
    defaultCheckedKeys(oldVal, newVal) {
      this.hasChangeCheck = false;
    },
    expandAll(oldVal, newVal) {
      this.$refs.Tree.$children.forEach(item => {
        this.expandTreeItem(item, newVal);
      });
    }
    // treeData(newVal) {

    // },
  },
  mounted() {
    if (this.treeData && this.treeData.length) {
      const [item] = this.treeData;
      item.id = item.id.length ? item.id : "xxxxxxxxxxxxxxx";
      this.defaultRootId = item.id;
    }
  },
  methods: {
    // 获取选中节点
    getCheckedKeys() {
      const array = [];
      this.$refs.Tree.getCheckedKeys().forEach(element => {
        if (element !== "xxxxxxxxxxxxxxx") {
          array.push(element);
        }
      });
      return array;
    },
    getHalfCheckedKeys() {
      const array = [];
      this.$refs.Tree.getHalfCheckedKeys().forEach(element => {
        if (element !== "xxxxxxxxxxxxxxx") {
          array.push(element);
        }
      });
      return array;
    },
    getCheckChange() {
      return this.hasChangeCheck;
    },
    checkChange(node, isCheck) {
      // 非父子联动情况
      if (!this.strictly) {
        // 选中则设置父为选中
        isCheck && this.collectionParentKeys(node, this.treeData).forEach(key => this.$refs.Tree.setChecked(key, true));
        // // 取消选中则设置子为未选中
        !isCheck && this.collectionChildrenKeys(node.children).forEach(key => this.$refs.Tree.setChecked(key, false));
      }
      this.hasChangeCheck = true;
    },
    expandTreeItem(item, expanded) {
      item.$children.forEach(element => {
        element.expanded = expanded;
        this.expandTreeItem(element);
      });
    },
    // 收集父级keys
    collectionParentKeys(node, data, keys = []) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // 找到直接return
        if (item.id === node.id) {
          return keys;
        }
        keys.push(item.id);

        if (Array.isArray(item.children)) {
          const findKeys = this.collectionParentKeys(node, item.children, keys);

          // 找到keys
          if (findKeys.length) {
            return findKeys;
          }
        }

        // 均未找到
        keys.pop();
      }

      return [];
    },
    // 收集子级keys
    collectionChildrenKeys(nodes, keys = []) {
      if (Array.isArray(nodes)) {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          keys.push(node.id);

          if (Array.isArray(node.children)) {
            this.collectionChildrenKeys(node.children, keys);
          }
        }
      }
      return keys;
    }
  }
};
</script>

<style lang="scss" scoped>
$border-color__ccc: #ccc;
ul,
.role--table--head {
  width: 100%;
  min-width: 450px;
  ul {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    border: 1px solid $border-color__ccc;
    height: 40px;
    background-color: #eaedf3;

    font-size: $scim-font-size-base;
    font-weight: 500;
    text-align: left;
    color: $scim-text-color;
    line-height: 40px;

    .li_1 {
      display: flex;
    }
    .checkbox {
      margin-left: $scim-space-row-lg;
      margin-right: 0;
      color: $scim-text-color;
    }

    li:nth-child(1) {
      padding-left: 10px;
      min-width: 200px;
      flex: 1;
    }
    li:nth-child(2) {
      padding-left: 10px;
      border-left: 1px solid $border-color__ccc;
      width: 206px;
    }
  }
}
.custom-tree-node {
  flex: 1;
  min-width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  span:nth-child(2) {
    display: inline-block;
    width: 200px;
    height: calc(100% + 2px);
    line-height: 40px;
    border-left: 1px solid $border-color__ccc;
    padding-left: 10px;
    text-align: left;
  }
}
::v-deep .el-tree .el-tree-node__content {
  position: relative;
  width: 100%;
  min-width: 420px;
  line-height: 28px;
  height: 36px;
  border: 1px solid $border-color__ccc;
  border-top: none;
}

::v-deep .el-tree .el-tree-node > .el-tree-node__children {
  overflow: inherit;
}
::v-deep .el-tree .el-tree__empty-block {
  border: 1px solid $border-color__ccc;
  border-top: none;
}
//固定表头
.el-tree {
  width: 100%;
  min-width: 450px;
  display: inline-block;
  overflow: auto;
  height: 500px;
}
.el-tag {
  height: 24px;
  line-height: 24px;
}
</style>
